"use client";

import { IBetRequest, IMaxTicketAmountResponse } from "@finbackoffice/clientbff-client";
import { ClientBFFContext } from "@finbackoffice/site-core";
import { BetSlipContextV2, ExchangeRatesContextV2, WalletsContext } from "contexts";
import { useCallback, useContext, useState } from "react";

export const useLimits = () => {
    const client = useContext(ClientBFFContext);
    const { betType } = useContext(BetSlipContextV2);
    const { currentWallet } = useContext(WalletsContext);
    const { minBet, maxBet, maxWin } = useContext(ExchangeRatesContextV2);
    const [isLoadingBetMax, setIsLoadingBetMax] = useState(false);

    const getPossibleBetMax = useCallback(
        (outcomeValue: number) => {
            const possibleMaxBet = maxWin / outcomeValue;

            if (possibleMaxBet <= maxBet) {
                return possibleMaxBet;
            }

            return maxBet;
        },
        [maxBet, maxWin],
    );

    const requestBetMax = useCallback(
        async (bets: IBetRequest[]) => {
            if (currentWallet?.id) {
                let response: IMaxTicketAmountResponse | null = null;
                setIsLoadingBetMax(true);

                try {
                    response = await client.calculateMaxBet({
                        bets,
                        type: betType,
                        wallet_id: currentWallet?.id,
                    });

                    setIsLoadingBetMax(false);
                    return response;
                } catch (error) {
                    console.error(error);
                    // TODO: add auth error message
                    // TODO: add betmax error message
                }
            }
            return null;
        },
        [betType, client, currentWallet?.id],
    );

    return {
        getPossibleBetMax,
        siteMinBet: minBet,
        siteMaxWin: maxWin,
        requestBetMax,
        isLoadingBetMax,
    };
};
